//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbBanner from '@/elements/editorial/rb-banner/rb-banner.vue'

import RbDynamicGridSmartBox from './dynamic-grid-smart-box'
import { MOBILE } from '@/scripts/constants/media-query'

export default {
  name: 'rb-smart-box',
  components: {
    RbDynamicGridSmartBox,
    RbBanner,
  },
  props: {
    /*
     * Flip Props
     */
    verticalFlip: {
      type: Boolean,
      default: false,
    },
    horizontalFlip: {
      type: Boolean,
      default: false,
    },
    verticalFlipOnlyDesktop: {
      type: Boolean,
      default: false,
    },
    isCopyExternal: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    computedClasses() {
      return {
        ['smart-box--elements-count-' + this.swiperSlides.length]: this.swiperSlides.length,
      }
    },
    swiperSlides() {
      return this.$slots.other_elements.filter((slot) => !!slot.tag)
    },
    isVerticalFlip() {
      if (this.$mq === MOBILE) {
        if (this.verticalFlipOnlyDesktop) {
          return 'order-0'
        } else {
          return [
            this.verticalFlip ? 'verticalFlip' : '',
            this.swiperSlides.length === 2 ? 'col-sm-8 col-md-10' : 'col-6',
          ]
        }
      } else {
        return [
          this.verticalFlip ? 'verticalFlip' : '',
          this.verticalFlipOnlyDesktop ? 'verticalFlip' : '',
          this.swiperSlides.length === 2 ? 'col-sm-8 col-md-9' : 'col-6',
        ]
      }
    },
    isHorizontalFlip() {
      if (this.$mq === MOBILE) {
        if (this.verticalFlipOnlyDesktop) {
          return 'order-0'
        } else {
          return [
            this.horizontalFlip ? 'horizontalFlip' : '',
            this.swiperSlides.length === 2 ? 'col-sm-4 col-md-2' : 'col-6',
          ]
        }
      } else {
        return [
          this.horizontalFlip ? 'horizontalFlip' : '',
          this.swiperSlides.length === 2 ? 'col-sm-4 col-md-3' : 'col-6',
        ]
      }
    },
  },
}
